import * as React from "react";
//import "driver.js/dist/driver.min.css";
import { TutorialContextContent } from "../Helpers/tutorial";

const useTutorial = (): {
  tutorialPage: TutorialContextContent["tutorialPage"];
  tutorialTitle: TutorialContextContent["tutorialTitle"];
  setTutorialPage: TutorialContextContent["setTutorialPage"];
  updateTutorialState: TutorialContextContent["updateTutorialState"];
} => {
  const [tutorialPage, setTutorialPage] = React.useState<TutorialContextContent["tutorialPage"]>();
  const [tutorialTitle, setTutorialTitle] = React.useState<TutorialContextContent["tutorialTitle"]>("");

  const updateTutorialState = React.useCallback((title: string, index: number) => {
    setTutorialTitle(title);
  }, []);
  return {
    tutorialPage,
    tutorialTitle,
    setTutorialPage,
    updateTutorialState,
  };
};

export default useTutorial;
